import { Component, OnInit, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';

import { EncrDecrService } from '../services/encr-decr.service';
import { SoaImageService } from '../services/soa-image.service';
import { ContactService } from '../services/contact.service';

import { saveAs } from 'file-saver';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css'],
  providers: [DatePipe]
})
export class ReportComponent implements OnInit {
  modalRef: BsModalRef;
  config: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };

  config1: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-xl'
  };

  loaderMode: boolean = false;
  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  currentUserRole: any = '';
  abc: any = [];
  customer_id: any = '';
  date_month: any = '';
  start_date: any = '';
  end_date: any = '';
  reportList: any = [];
  totalRow: any = [];
  tableColumns: any = [];
  tableOrder: any = [];

  isStartDateDisabled: boolean = true;
  isEndDateDisabled: boolean = true;
  endMinDate: any = '';
  startmaxDate: any = '';
  customerFilter: object = [];

  emailModel: any = {};
  pdfSrc: any = '';
  folderid: any = 0;
  //search and select
  dropdownList1: { id: number; itemName: string; }[];
  selectedItems1: { id: number; itemName: string; }[];
  dropdownSettings1: { showCheckbox: boolean; singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; classes: string; };
  // reportJsonData:any=[];
  reportCsvPath: any = '';
  myDate: any = new Date();
  attachfile: any = '';
  constructor(
    private http: HttpClient,
    private _soaImage: SoaImageService,
    private _contact: ContactService,
    private modalService: BsModalService,
    private EncrDecr: EncrDecrService,
    private _router: Router,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,
    private datePipe: DatePipe
  ) { }

  dtOptionsList: DataTables.Settings = {};

  ngOnInit() {
    this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this.abc = localStorage.getItem('currentUser');
    var obj = JSON.parse(this.abc);

    this.currentUserRole = localStorage.getItem('role_name');

    this.loaderMode = true;

    // console.log('this.loaderMode', this.loaderMode);
    this.isStartDateDisabled = true;
    this.isEndDateDisabled = true;
    this.date_month = 'this_week';

    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
    }

    //get mobile folder customer list
    this._soaImage.getMobileFiltterData(customerModal)
      .subscribe(
        res => {

          var i = 0;
          for (let item of res.data.customers) {
            {
              // console.log(item['customer_id']);
              this.dropdownList1.push({ 'id': item['customer_id'], 'itemName': item['company_name'] });
            }
            i++;
          }
        },
      );

    this.dropdownList1 = [];
    this.selectedItems1 = [];
    this.dropdownSettings1 = {
      showCheckbox: false,
      singleSelection: true,
      text: "All Customers",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: " "
    };
    this.loadDatatable();
  }

  onChangePaymentStatus(folderId, invPaymentStatus) {
    this.loaderMode = true;
    const updateModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      folder_id: folderId,
      inv_payment_status: invPaymentStatus,
    }

    //get mobile folder list 
    this._soaImage.updateInvPaymentStatus(updateModal)
      .subscribe(
        res => {
          this.loaderMode = false;
          if (res.status == true) {
            this.toastr.success(res.message, 'Success');
          } else {
            this.toastr.error(res.message, 'Error');
          }
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/report');
          });
        },
      );

  }

  redirectEditInvoice(id) {
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), id);
    this._router.navigate(["/", 'mobile', 'edit-mobile', encrypted + '~~ei']);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }


  getCustomerEmail(customer_id, filder_id, attachfile) {
    this.attachfile = attachfile;

    this.loaderMode = true;
    this.folderid = filder_id;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      customer_id: customer_id,
    }

    this._contact.getContactEmailsByid(folderModel).subscribe(
      res => {
        this.loaderMode = false;
        this.emailModel = res.data;
      },
    );
  }

  sendInvoiceEmail() {
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      email_info: this.emailModel,
      folder_id: this.folderid,
      attachfile: this.attachfile
    }

    this._soaImage.sendInvoiceEmail(folderModel).subscribe(
      res => {
        this.modalRef.hide();

        if (res.status == true) {
          this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }

      },
    );
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config1);
  }

  setpdfSrc(src) {
    this.pdfSrc = src; //'https://soav3.mybizpad.com/trucking_rest_api/uploads/system_file/mobile_folder_doc/company_17/MOB00077/final/final.pdf' ;
  }

  onChangeCustomer(value) {
    this.loaderMode = true;
    // console.log(value.id);
    this.customer_id = value.id;
    $('#dataTables_example').DataTable().draw();
  }

  onChangeDateMonth(value) {
    this.date_month = value;
    if (this.date_month == 'custom') {
      this.isStartDateDisabled = false;
      this.loaderMode = false;
      this.startmaxDate = this.myDate;
    } else {
      this.loaderMode = true;
      this.isStartDateDisabled = true;
      this.isEndDateDisabled = true;
      $("#txtStartDate").val('');
      $("#txtEndDate").val('');
      $('#dataTables_example').DataTable().draw();
    }

  }

  onChangeStartDate(value) {
    this.loaderMode = true;
    this.start_date = value;
    this.isEndDateDisabled = false;
    this.endMinDate = this.start_date;

    /*console.log('this.start_date ',this.start_date ) ;
    console.log('this.myDate ',this.myDate) ;
    console.log('this.end_date ',this.end_date) ;*/
    if (this.end_date == '') {
      $("#txtEndDate").val(this.myDate);
    }

    $('#dataTables_example').DataTable().draw();
  }

  onChangeEndDate(value) {
    this.loaderMode = true;
    this.end_date = value;
    $('#dataTables_example').DataTable().draw();
  }

  loadDatatable() {
    this.loaderMode = false;
    this.tableColumns = [{ data: 'mobile_image_header.id' }, { data: 'mobile_image_header.mobile_number' }, { data: 'customer.company_name' }, { data: 'mobile_image_header.inv_created_date' }, { data: 'mobile_image_header.inv_due_date' }, { data: 'users.first_name' }, { data: 'customer.terms' }, { data: 'mobile_image_header.work_week' }, { data: 'mobile_image_header.reference_number' }, { data: 'mobile_image_header.po_number' }, { data: 'mobile_image_header.sub_total_inv' }, { data: 'mobile_image_header.inv_payment_status' }, { data: 'mobile_image_header.inv_status' }];
    this.tableOrder = [[1, 'desc']];

    this.dtOptionsList = {
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [25, 50, 100, 150],
      columnDefs: [{
        'targets': [0], // column index (start from 0)
        'orderable': false, // set orderable false for selected columns
      }],
      order: this.tableOrder,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.minNumber = dataTablesParameters.start + 1;
        dataTablesParameters.maxNumber = dataTablesParameters.start + dataTablesParameters.length;

        dataTablesParameters.APIKEY = this.APIKEY;
        dataTablesParameters.user_id = this.user_id;
        dataTablesParameters.company_id = this.company_id;
        dataTablesParameters.status = 'active';

        dataTablesParameters.customer_id = this.customer_id;
        dataTablesParameters.date_month = this.date_month;
        dataTablesParameters.start_date = this.start_date;
        dataTablesParameters.end_date = this.end_date;

        this.http
          .post<DataTablesResponse>(
            environment.api + '/Report/getReportAjax',
            dataTablesParameters
          )
          .subscribe((resp: any) => {
            this.loaderMode = false;

            if (resp.status == true) {
              this.reportList = resp.data;
              // console.log(this.reportList);
              this.totalRow = resp.total;
            }

            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: this.tableColumns
    };
  }

  downloadReportCsv() {
    this.loaderMode = true;
    const reportModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
      customer_id: this.customer_id,
      date_month: this.date_month,
      start_date: this.start_date,
      end_date: this.end_date
    }
    //get mobile folder list 
    this._soaImage.downloadReportCsv(reportModal)
      .subscribe(
        res => {
          this.loaderMode = false;
          this.reportCsvPath = res.url;
          this.forceDownload(this.reportCsvPath);
        },
      );
  }
  forceDownload(url) {
    var fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
    //console.log('CSV fileName' , fileName) ;
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (d: any) => {
        saveAs(d, fileName);
      },
      (err: any) => {
        console.log("error", err)
      }
    )

  }
  onDeSelectAllCust(items: any) {
    // console.log('customer unselect' + items);
    this.customer_id = '';
    $('#dataTables_example').DataTable().draw();
  }
}
